import { message, Popconfirm } from 'antd';
import { Buffer } from 'buffer';
import { useDispatch, useSelector } from 'react-redux';
import { apiResponseModalSliceDispatch, uploadFileSliceDispatch } from "../../Constants/ReduxConstants";
import UploadFileService from "../../Services/UploadFileService";
import IUploadFileType from '../../Types/UploadFileType';

const UploadTemplate = () => {
    const isLoading = useSelector((state: any) => state.refreshLoadedFile.isLoading);
    const currentFileLength = useSelector((state: any) => state.pickAFile.fileLength);

    const currentDataContents = useSelector((state: any) => state.pickAFile.currentDataContents);
    const currentFileName = useSelector((state: any) => state.pickAFile.fileName);

    const dispatch = useDispatch();

    const confirm = () => {
        message.success('Uploading...');
        UploadFile();
    };

    const cancel = () => {
        message.error('Canceling...');
    };

    async function UploadFile() {
        let isApiCallSuccessful: boolean = false;

        let filePath = "/template/" + currentFileName;

        //Get the last commitId for upload post request and tree url for repo get request.
        let commitId: string = "";
        let treeUrl: string = "";

        await UploadFileService.getTemplateFileRepoURL()
            .then(response => {
                if (response.status == 200) {
                    isApiCallSuccessful = true;

                    commitId = response.data.commitId;
                    treeUrl = response.data._links.tree.href
                }
                else {
                    isApiCallSuccessful = false;

                    dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                    dispatch({ type: uploadFileSliceDispatch.setApiResponse, payload: response.data })
                }
            })
            .catch((e) => {
                isApiCallSuccessful = false;

                commitId = "";
                treeUrl = "";
                dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                dispatch({ type: uploadFileSliceDispatch.setApiResponse, payload: e.message })
            });;

        //Get tree entries/list of files present in repo.
        let changeType: string = "";
        let files: string[] = []

        if (isApiCallSuccessful) {
            await UploadFileService.getTemplateFileRepoEntities(treeUrl)
                .then(response => {
                    if (response.status == 200) {
                        isApiCallSuccessful = true;

                        response.data.treeEntries.forEach(x => files.push(x.relativePath))

                        !files.includes(currentFileName) ? changeType = "add" : changeType = "edit";
                    }
                    else {
                        isApiCallSuccessful = false;

                        dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                        dispatch({ type: uploadFileSliceDispatch.setApiResponse, payload: response.data })
                    }
                })
                .catch((e) => {
                    isApiCallSuccessful = false;

                    dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                    dispatch({ type: uploadFileSliceDispatch.setApiResponse, payload: e.message })
                });;
        }

        //Post new file. 
        //JSON.stringify overload with , null, 4 formats the json file to match typical format. 4 being the spacing indentation.
        let base64currentDataContents: string = Buffer.from(JSON.stringify(JSON.parse(currentDataContents), null, 4)).toString("base64");

        let data: IUploadFileType = {
            refUpdates: [{
                name: "refs/heads/develop",
                oldObjectId: commitId
            }],
            commits: [{
                comment: changeType == "add" ? "Added new image file."
                    : changeType == "edit" ? "Edited image file."
                        : "",
                changes: [{
                    changeType: changeType,
                    item: {
                        path: filePath
                    },
                    newContent: {
                        content: base64currentDataContents,
                        contentType: "base64encoded"
                    }
                }]
            }]
        }

        if (isApiCallSuccessful) {
            await UploadFileService.postTemplateFile(data)
                .then(response => {
                    if (response.status != 201) {
                        isApiCallSuccessful = true;

                        dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                        dispatch({ type: uploadFileSliceDispatch.setApiResponse, payload: response.data })
                    }
                    else {
                        isApiCallSuccessful = false;

                        dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                        dispatch({ type: uploadFileSliceDispatch.setApiResponse, payload: "File successfully uploaded." })
                    }
                })
                .catch((e) => {
                    isApiCallSuccessful = false;

                    dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                    dispatch({ type: uploadFileSliceDispatch.setApiResponse, payload: e.message })
                });;
        }
    }

    const upload = (
        <Popconfirm
            title="Are you sure you wish to upload this template?"
            onConfirm={confirm}
            onCancel={cancel}
            okText="Yes"
            cancelText="No"
        >
            <button disabled={currentFileLength == null || isLoading} title="Save & Upload Template">Save & Upload Template</button>
        </Popconfirm>
    )

    return upload;
}

export default UploadTemplate;